import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import StyledChart from './components/chart/styles';
import ScrollToTop from './components/scroll-to-top';
import ErrorBoundary from './components/error-boundary';
import { PwaStatus } from './components/pwa';
import 'react-toastify/dist/ReactToastify.css';
// ----------------------------------------------------------------------

export default function App() {
  return (
    <>
      <ToastContainer position="top-left" autoClose={5000} hideProgressBar newestOnTop />
      <HelmetProvider>
        <BrowserRouter>
          <ThemeProvider>
            <ScrollToTop />
            <StyledChart />
            <PwaStatus />
            <ErrorBoundary>
              <Router />
            </ErrorBoundary>
          </ThemeProvider>
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}
